import IncidentMechanismsAtAGlanceGraph from './IncidentMechanismsAtAGlanceGraph';

export default IncidentMechanismsAtAGlanceGraph;
